.button {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: 10px;
}